import { render, staticRenderFns } from "./Redirect.vue?vue&type=template&id=6ca03c16&scoped=true&"
import script from "./Redirect.vue?vue&type=script&lang=js&"
export * from "./Redirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca03c16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/pushhike/pushhike-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ca03c16')) {
      api.createRecord('6ca03c16', component.options)
    } else {
      api.reload('6ca03c16', component.options)
    }
    module.hot.accept("./Redirect.vue?vue&type=template&id=6ca03c16&scoped=true&", function () {
      api.rerender('6ca03c16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Redirect.vue"
export default component.exports